"use client";
import React from "react";
 
import Link from "next/link";
import { usePathname } from "next/navigation";
const links = [
  { href: "/dedicated-servers-usa", label: "Dedicated Servers" },
  { href: "/dedicated-seo-servers", label: "Dedicated SEO Servers" },
  { href: "/dedicated-reseller", label: "Dedicated Reseller" },
  { href: "/dedicated-special-deals", label: "Dedicated Special Deals" },
];

const ServerPackagesDedRes = () => {
  const pathname = usePathname();

  return (
    <div className="container mt-4">
      <div className="text-center my-lg-5">
        <h1 className="display-5 fw-bold">
          <span className="text-capitalize">Ultimate Dedicated Servers Experience</span>  
        </h1>
        <p className="fs-5 fw-normal"> 
          Discover the ultimate in hosting performance and control
        </p> 
      </div>

      <div className="btnGroup my-4">
        {links.map(({ href, label }, index) => {
          const isActive = pathname === href;
          return (
            <Link 
              key={index} 
              href={href}
              className={`mx-2 my-1 btn btn-lg ${
                isActive 
                ? "darkOne" 
                : "outline-darkZero"
              }`}
            >
              {label}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default ServerPackagesDedRes;